<div class="modal-header">
  <h4 class="modal-title pull-left">Complete captcha</h4>
  <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="d-flex justify-content-center py-4">
    <re-captcha (resolved)="resolved($event)" siteKey="6LerhdoUAAAAALNDBc-55hTv75JuT_hZmYYtdBZG"></re-captcha>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-default" (click)="bsModalRef.hide()">Close</button>
</div>
